import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
// no checkbox/list-item-text needed for single select
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { format } from 'date-fns';
import './styling/PhoneForm.css';

export default function PhoneForm({ onSubmit, loading }) {
    const [phone, setPhone] = useState('');
    const [dob, setDob] = useState(null);
    const [selectedCourse, setSelectedCourse] = useState('');

    const availableCourses = [
        "TALLY",
        "DCA",
        "ADCA",
        "DTP",
        "PGDCA",
        "BCC",
    ];

    function handleSubmit(e) {
        e.preventDefault();
        if (!phone) return alert('Please enter phone number');
        if (!dob) return alert('Please enter date of birth');
        if (!selectedCourse) return alert('Please select a course');
        onSubmit({ phone: phone.trim(), dob: format(dob, 'dd/MM/yyyy'), course: selectedCourse });
    }

    return (
        <form className="phone-form" onSubmit={handleSubmit}>
            <h2>Certificate Portal</h2>
            <p>
                Enter the registered phone number and date of birth to view/download the certificate
            </p>

            <TextField
                label="Phone number"
                value={phone}
                onChange={(e) => setPhone(e.target.value.replace(/[^0-9]/g, ''))}
                placeholder=""
                inputProps={{ maxLength: 10 }}
                fullWidth
                margin="normal"
            />

            <div className="course-select input-label">
                <FormControl fullWidth margin="normal">
                    <InputLabel id="course-select-label">Course</InputLabel>
                    <Select
                        labelId="course-select-label"
                        id="course-select"
                        value={selectedCourse}
                        onChange={(e) => setSelectedCourse(e.target.value)}
                        renderValue={(selected) => selected}
                    >
                            {availableCourses.map((course) => (
                                <MenuItem key={course} value={course}>
                                    {course}
                                </MenuItem>
                            ))}
                    </Select>
                </FormControl>
            </div>

            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                    label="Date of Birth"
                    value={dob}
                    onChange={(date) => setDob(date)}
                    maxDate={new Date()}
                    format="dd/MM/yyyy"
                    disableFuture
                    clearable
                    slotProps={{
                        textField: {
                            placeholder: "DD/MM/YYYY",
                            fullWidth: true,
                            margin: "normal"
                        }
                    }}
                />
            </LocalizationProvider>

            <div className="form-actions">
                <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    disabled={loading}
                    fullWidth
                >
                    {loading ? 'Checking...' : 'Get Certificate'}
                </Button>
            </div>

            <div className="note">
                <small>
                    Sample for testing: 9876543210 (12/04/1995), 9123456780 (05/11/1998), 9001122334 (20/02/1992)
                </small>
            </div>
        </form>
    );
}
